module.exports = __webpack_public_path__ + "static/media/nl.a96fbfa1.svg";